import { IFundClass } from '@mais-retorno-front/libs/util-models';
import { HTTP_STATUS_CODE, IHttpGet } from '../../adapters';
import { FUND_STATUS_TYPE } from '../../constants';
import {
  IRedirectUrl,
  ISheetFundHeader,
  ISheetFundStats,
} from '../../interfaces';
import { IResponseDTO } from './dto';

export class SheetFundHeaderUseCase {
  private readonly redirectUrl = 'funds/redirect';
  private readonly fundRoutePath = 'fundo';

  constructor(
    private readonly baseUrl: string,
    private readonly http: IHttpGet<
      ISheetFundHeader | ISheetFundStats | IRedirectUrl
    >
  ) {}

  async execute(fundSlug: string): Promise<IResponseDTO> {
    const { statusCode, body } = await this.http.get<ISheetFundHeader>({
      url: `${this.baseUrl}/funds/header/${fundSlug}/full`,
    });

    if (
      statusCode === HTTP_STATUS_CODE.unexpected ||
      statusCode === HTTP_STATUS_CODE.severError
    ) {
      throw body;
    }

    if (statusCode === HTTP_STATUS_CODE.notFound) {
      const redirect = await this.redirectFund(fundSlug);

      return { redirect, notFound: !redirect };
    }

    if (body.status === FUND_STATUS_TYPE.preOperational) {
      return {
        fundHeader: body,
      };
    }

    return {
      fundHeader: {
        ...body,
        ...this.createClassAndSubclass(body),
      },
    };
  }

  private createClassAndSubclass(fundHeader: ISheetFundHeader): {
    class: IFundClass;
    subclass: IFundClass;
  } {
    if (!fundHeader?.fund_class?.class?.slug) {
      return {
        class: fundHeader.class,
        subclass: {
          ...fundHeader.subclass,
          slug: `${fundHeader.class.slug}/${fundHeader.subclass.slug}`,
        },
      };
    }

    return fundHeader.fund_class;
  }

  private async redirectFund(fundSlug: string) {
    const { statusCode, body } = await this.http.get<IRedirectUrl>({
      url: `${this.baseUrl}/${this.redirectUrl}`,
      params: { url: `/${this.fundRoutePath}/${fundSlug}` },
    });

    if (statusCode === HTTP_STATUS_CODE.ok) {
      return body.new_path;
    }

    return null;
  }
}
